import React, {useEffect, useState} from "react";
import Layout from "../Layout";
import {FaUsers, FaChartLine, FaUserPlus, FaCalendarWeek, FaCalendarDay} from "react-icons/fa";
import './HomePage.css';

const HomePage = () => {
    const [userStats, setUserStats] = useState({
        total_users: 0,
        new_users_last_month: 0,
        monthly_growth: "",
        new_users_last_week: 0,
        weekly_growth: "",
        new_users_last_day: 0,
    });

    useEffect(() => {
        const accessToken = localStorage.getItem("accessToken");

        const fetchData = async () => {
            try {
                const response = await fetch("https://api.edumonics.in/admin/user-stats", {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    setUserStats(data);
                } else {
                    console.error("Failed to fetch data");
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);

    return (
        <Layout pageTitle="Edumonics Admin Dashboard">
            <div
                className="homepage-container"
                style={{
                    maxWidth: "1200px",
                    margin: "auto",
                    padding: "40px",
                    textAlign: "center",
                    fontFamily: "Gotham, sans-serif",
                }}
            >
                {/* Header Section */}
                <div
                    className="welcome-section"
                    style={{
                        marginBottom: "40px",
                    }}
                >
                    <h1
                        className="title"
                        style={{
                            fontSize: "2.5rem",
                            fontWeight: "bold",
                            color: "#FAD049", // Yellow heading color
                            fontFamily: "Gotham, sans-serif",
                            textTransform: "uppercase",
                        }}
                    >
                        Welcome to Edumonics
                    </h1>
                    <p
                        className="subtitle"
                        style={{
                            fontSize: "1.2rem",
                            color: "#000000", // Black text color
                        }}
                    >
                        A powerful admin dashboard to manage users and educational content.
                    </p>
                </div>

                {/* Statistics Cards */}
                <div
                    className="card-container"
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "20px",
                        justifyContent: "center",
                    }}
                >
                    {[
                        {
                            icon: <FaUsers className="card-icon"/>,
                            title: "Total Users",
                            stat: userStats.total_users,
                        },
                        {
                            icon: <FaUserPlus className="card-icon"/>,
                            title: "New Users Last Month",
                            stat: userStats.new_users_last_month,
                        },
                        {
                            icon: <FaChartLine className="card-icon"/>,
                            title: "Monthly Growth",
                            stat: userStats.monthly_growth,
                        },
                        {
                            icon: <FaCalendarWeek className="card-icon"/>,
                            title: "New Users Last Week",
                            stat: userStats.new_users_last_week,
                        },
                        {
                            icon: <FaChartLine className="card-icon"/>,
                            title: "Weekly Growth",
                            stat: userStats.weekly_growth,
                        },
                        {
                            icon: <FaCalendarDay className="card-icon"/>,
                            title: "New Users Last Day",
                            stat: userStats.new_users_last_day,
                        },
                    ].map((card, index) => (
                        <div
                            key={index}
                            className="card"
                            style={{
                                width: "250px",
                                padding: "20px",
                                textAlign: "center",
                                backgroundColor: "#FFFFFF",
                                boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.2)", // Slightly enhanced shadow
                                borderRadius: "16px", // Modern rounded corners
                                transition: "transform 0.3s ease-in-out",
                            }}
                            onMouseOver={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
                            onMouseOut={(e) => (e.currentTarget.style.transform = "translateY(0)")}
                        >
                            <div
                                style={{
                                    fontSize: "50px",
                                    color: "#FAD049", // Yellow icon color
                                    marginBottom: "15px",
                                }}
                            >
                                {card.icon}
                            </div>
                            <h3
                                style={{
                                    fontSize: "1.2rem",
                                    fontFamily: "Gotham, sans-serif",
                                    color: "#000000", // Black heading color
                                    marginBottom: "10px",
                                }}
                            >
                                {card.title}
                            </h3>
                            <p
                                style={{
                                    fontSize: "1rem",
                                    color: "#000000", // Black text color
                                }}
                            >
                                {card.stat}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </Layout>
    );
};

export default HomePage;
